var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 32",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "shop-icon__wrapper",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "shop-icon__wrapper",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "shop-icon__wrapper",
    transform: "translate(5.500000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "shop-icon__wrapper",
    transform: "translate(2.900000, 3.520823)",
    fill: "#0350a5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shop-icon__bmw-logo-second-panel",
    d: "M8.314997,4.1574985 L4.1574985,4.1574985 L4.1574985,7.99360578e-15 C6.45534179,7.99360578e-15 8.314997,1.85977296 8.314997,4.1574985"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shop-icon__bmw-logo-second-panel",
    d: "M4.1574985,4.1574985 L4.1574985,8.314997 C1.85969161,8.314997 9.76996262e-15,6.45526043 9.76996262e-15,4.1574985 L4.1574985,4.1574985 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shop-icon__bmw-logo",
    d: "M4.1574985,7.99360578e-15 L4.1574985,4.1574985 L9.76996262e-15,4.1574985 C9.76996262e-15,1.85977296 1.85969161,7.99360578e-15 4.1574985,7.99360578e-15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shop-icon__bmw-logo",
    d: "M8.314997,4.1574985 C8.314997,6.45526043 6.45534179,8.314997 4.1574985,8.314997 L4.1574985,4.1574985 L8.314997,4.1574985 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "shop-icon__inner-border",
    stroke: "#0350a5",
    strokeWidth: 0.3,
    cx: 7.05,
    cy: 7.65,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "shop-icon__inner-border",
    stroke: "#0350a5",
    strokeWidth: 0.8,
    cx: 7,
    cy: 7.7,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "shop-icon__wrapper",
    stroke: "#0350a5",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    className: "shop-icon__wrapper",
    transform: "translate(0.639237, 0.580543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shop-icon__outer-border",
    d: "M10.860763,27.9296188 C11.5009587,28.6283284 11.8929587,29.0328446 11.8929587,29.0328446 C11.8929587,29.0328446 12.2806978,28.626393 12.9145022,27.9218768"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shop-icon__outer-border",
    d: "M15.0204152,25.6151671 C18.4418935,21.558393 23.535763,14.8132317 23.535763,10.6200059 C23.535763,4.30742521 18.37585,0.00581230691 12.0175674,2.29150032e-13 C5.64437174,-0.00580059632 0.260763043,4.30742521 0.260763043,10.6200059 C0.260763043,15.2477478 6.56258913,22.9848446 9.92761087,26.7861349",
    strokeDasharray: "3.042,3.042"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.3d7fa9be1a1f6b075761030af09156ef.svg";
export { ForwardRef as ReactComponent };